import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { DispatchAiSummaryBus } from '@app/cp/shared/models/DispatchAiSummaryBus';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';

@Component({
    selector: 'dispatch-summary',
    templateUrl: './dispatch-summary.component.html',
    styleUrls: ['./dispatch-summary.component.scss'],
    standalone: false
})
export class DispatchSummaryComponent implements OnChanges {
    @Input() parentId: string;
    @Input() referenceData: any;
    @Input() dataLoading: boolean = false;
    @Output() parentMessage: EventEmitter<any> = new EventEmitter<any>();

    summary: DispatchAiSummaryBus;
    loading: boolean = false;

    constructor(private svc_data: DispatchesService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.parentId) {
            this.getData();
        }
    }

    get hasSummary(): boolean {
        return CommonFunctions.hasValue(this.summary?.summary) && this.summary.summary.trim().length > 0;
    }

    getData(): void {
        this.summary = null;
        if (!CommonFunctions.hasGuidValue(this.parentId)) {
            return;
        }

        this.loading = true;
        this.svc_data.getDispatchSummary(this.parentId).subscribe({
            next: (data: DispatchAiSummaryBus) => {
                this.summary = data;
                this.loading = false;
            },
            error: () => {
                this.summary = null;
                this.loading = false;
            }
        });
    }
}
